import React, { useState, useEffect, useContext } from "react";
import { Footer, Header, InputTypePhone } from "../../components";
import "./styles.css";
import { Images } from "../../theme";
import { Link } from "react-router-dom";
import InputTextCustom from "../../components/InputTextCustom";
import { AuthContext } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function Profile() {
  const userContextData = useContext(AuthContext);
  let { user_data, loginData, profile_all_status, profileStatus, imageUrl } =
    userContextData;

  console.log(profileStatus, "profileStatusprofileStatus");

  const { t } = useTranslation();

  useEffect(() => {
    user_data();
    profile_all_status();
  }, []);

  return (
    <>
      <Header />
      <div className="container">
        <div className="row mt-4">
          <div className="col-md-3">
            <h1 className="withDrawHeading">{t("Profile_Details")}</h1>
          </div>
          <div className="col-md-9 col-12 btnMobileverification">
            <Link to="/IdentityVerification">
              <button class="btn-custom btn-light verificationBtn">
                {t("Identity_Verification")}
              </button>
            </Link>
            <Link to="/EditProfile">
              <button class="btn-custom btn-light BtneditProfile">
                {t("Edit_Profile")}
              </button>
            </Link>
          </div>
        </div>
        <div className="row mt-3 mb-5">
          <div className="col-md-3 mt-4">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-md-auto">
                <div>
                  <div className="profileImgBG">
                    <img
                      className="profileImage"
                      src={
                        loginData.profileImagePath
                          ? `${imageUrl}${loginData.profileImagePath}`
                          : Images.profileImage
                      }
                      alt="image"
                    />
                    {/* <div className="profileArrowBG">
                      <img
                        className="uploadImageStyle"
                        src={Images.uploadArrow}
                        alt="image"
                      />
                    </div> */}
                  </div>
                  <h1 className="profileName">
                    {loginData.firstname} {loginData.lastname}
                  </h1>
                  <p className="profileEmail">{loginData.email}</p>
                </div>
              </div>
            </div>
            <h1 className="statistics">{t("Statistics")}</h1>
            <Link to="/WithDraw">
              <div className="statisticsCard">
                <h1 className="statisticsPrice">
                  ${profileStatus?.earning ? profileStatus?.earning : 0}
                </h1>
                <div>
                  <span className="statisticsLifetime">
                    {t("Lifetime_Earnings")}
                  </span>
                  <img
                    className="statisticsImg"
                    src={Images.statistics}
                    alt="image"
                  />
                </div>
              </div>
            </Link>
            <div className="row m-0" style={{ width: "100%" }}>
              <div className="col-md-6 col-6 p-0 paddingRightCard">
                <Link to="/RentalsItems" state={{ rentalState: true }}>
                  <div className="CardStatic">
                    <span className="countStatic">
                      {profileStatus?.rents ? profileStatus?.rents : 0}
                    </span>
                    <br />
                    <span className="textStatic">{t("Rentals")}</span>
                  </div>
                </Link>
              </div>
              <div className="col-md-6 col-6 p-0 paddingLeftCard">
                <div className="CardStatic">
                  <span className="countStatic">
                    {profileStatus?.days ? profileStatus?.days : 0}
                  </span>
                  <br />
                  <span className="textStatic">{t("Days_With_Us")}</span>
                </div>
              </div>
            </div>

            <div className="row m-0" style={{ width: "100%" }}>
              <div className="col-md-6 col-6 p-0 paddingRightCard">
                <Link to="/RentalsItems" state={{ rentalState: false }}>
                  <div className="CardStatic">
                    <span className="countStatic">
                      {profileStatus?.lends ? profileStatus?.lends : 0}
                    </span>
                    <br />
                    <span className="textStatic">{t("Lends")}</span>
                  </div>
                </Link>
              </div>
              <div className="col-md-6 col-6 p-0 paddingLeftCard">
                <Link to="/Inbox">
                  <div className="CardStatic">
                    <span className="countStatic">0</span>
                    <br />
                    <span className="textStatic">{t("Unread_Messages")}</span>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-9">
            <div className="cardProfile">
              <div className="row">
                <div className="col-md-6 col-6">
                  <InputTextCustom
                    headingLabel={t("First_Name")}
                    value={loginData.firstname}
                    disabled={true}
                    placeholder={t("First_Name")}
                  />
                </div>
                <div className="col-md-6 col-6">
                  <InputTextCustom
                    headingLabel={t("Last_Name")}
                    value={loginData.lastname}
                    disabled={true}
                    placeholder={t("Last_Name")}
                  />
                </div>

                <div className="col-md-6">
                  <InputTextCustom
                    headingLabel={t("Email")}
                    value={loginData.email}
                    disabled={true}
                    placeholder={t("Email")}
                  />
                </div>
                <div className="col-md-6">
                  <InputTypePhone
                    headingLabel={t("Phone_Number")}
                    placeholder={t("Phone_Number")}
                    disabled={true}
                    value={loginData.phone}
                  />
                </div>
                <div className="col-lg-12 col-md-12 col-12">
                  <button className="btn location-btn">
                    {loginData.location ? loginData.location : t("Not_Set")}
                  </button>
                </div>

                <div className="col-md-12 col-12">
                  <label class="control-label customStyleLabel">
                    {t("Describe_Yourself")}
                  </label>
                  <div>
                    <textarea
                      id="w3review"
                      name="w3review"
                      rows="4"
                      disabled={true}
                      className="form-control textAreaStyle"
                      value={loginData.description}
                      placeholder={t("Describe_Your_self_Description")}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
